<div class="aspect-ratio-portrait" [ngStyle]="{'width': boxWidth + 'px'}">
    <iframe *ngIf="urlSecurized" [src]="urlSecurized" frameborder="0" allowfullscreen allowtransparency allow="autoplay"
        class="full-w" [ngClass]="viewClass"></iframe>
</div>